import baseURL from "../common/axios";
class Commonservices {
  listStockInMasterTM(code, DocType, StoreId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "/StockInMasterTM/ListByStockInCode?Code=" +
        code +
        "&DocType=" +
        DocType +
        "&StoreId=" +
        StoreId
    );
  }
  GetGRNListByPoId(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/GRNListByPoId?POId=" + data
    );
  }
  listStockInDetailTD() {
    return baseURL.httpMSInventoryUrl.get("/StockInDetailsTD/List");
  }
  // Geting list by Id
  getlistById(Id) {
    return baseURL.httpMSInventoryUrl.get(
      "/StockInMasterTM/GetByStockInId?id=" + Id + ""
    );
  }
  GetStockInDetailsByRefId(Id, ToStoreId, ToStoreBrMapId) {
    return baseURL.httpMSInventoryUrl.get(
      "/StockInMasterTM/GetStockInDetailsByRefId?id=" +
        Id +
        "&ToStoreId=" +
        ToStoreId +
        "&ToStoreBrMapId=" +
        ToStoreBrMapId
    );
  }

  getlistByStockInId(Id) {
    return baseURL.httpMSInventoryUrl.get(
      "/StockInMasterTM/GetAssetByStockInId?id=" + Id + ""
    );
  }
  getlistBySupplierId(SupplierId) {
    return baseURL.httpMSInventoryUrl.get(
      "/StockInMasterTM/GetBySupplierId?SupplierId=" + SupplierId + ""
    );
  }

  //Create StockInMas
  createStockInTM(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("StockInMasterTM/Create", data);
  }
  //Update StockInMAS
  updateStockInTM(data) {
    return baseURL.httpMSInventoryUrl.post("StockInMasterTM/Update", data);
  }
  DeleteStockInTM(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "StockInMasterTM/Delete?Id=" + data
    );
  }
  //Insert/Update StockIn Details
  createStockInDetails(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("StockInDetailsTD/Create", data);
  }
  createStockInDetailsDraft(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("StockInMasterTM/CreateDraft", data);
  }

  //Delete Stock Details
  deleteStockInDetails(data) {
    return baseURL.httpMSInventoryUrl.delete(
      "StockInDetailsTD/Delete?Id=" + data
    );
  }

  //Stock In List based on Type
  GetStockInTMTableList(docType, StoreId, HospitalId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/GetListByDocType?DocType=" +
        docType +
        "&StoreId=" +
        StoreId +
        "&HospitalId=" +
        HospitalId +
        ""
    );
  }

  //Stock In List based on Doc No
  GetStockInTMTableListByDocNo(docNo, StoreId, docType) {
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/GetListByDocNo?DocNo=" +
        docNo +
        "&StoreId=" +
        StoreId +
        "&docType=" +
        docType +
        ""
    );
  }

  GetDocNoByStoreId(StoreId, BranchId, HospitalId, Name, fromdate, todate) {
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/GetDocNoByStoreId?StoreId=" +
        StoreId +
        "&BranchId=" +
        BranchId +
        "&HospitalId=" +
        HospitalId +
        "&Name=" +
        Name +
        "&fromdate=" +
        fromdate +
        "&todate=" +
        todate +
        ""
    );
  }

  GetSalesOrderGRNNoByStoreId(
    StoreId,
    BranchId,
    HospitalId,
    Name,
    fromdate,
    todate
  ) {
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/GetSalesOrderGRNNoByStoreId?StoreId=" +
        StoreId +
        "&BranchId=" +
        BranchId +
        "&HospitalId=" +
        HospitalId +
        "&Name=" +
        Name +
        "&fromdate=" +
        fromdate +
        "&todate=" +
        todate +
        ""
    );
  }

  GetDocNoByBarCodeNo(
    FromStoreId,
    ToStoreId,
    FromStoreBranchId,
    ToStoreBranchId,
    HospitalId,
    BarCodeNo
  ) {
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/GetDocNoByBarCodeNo?FromStoreId=" +
        FromStoreId +
        "&ToStoreId=" +
        ToStoreId +
        "&FromStoreBranchId=" +
        FromStoreBranchId +
        "&ToStoreBranchId=" +
        ToStoreBranchId +
        "&HospitalId=" +
        HospitalId +
        "&BarCodeNo=" +
        BarCodeNo +
        ""
    );
  }
  //Stock In List based on Type
  // List(
  //   startDate,
  //   endDate,
  //   docType,
  //   PageNum,
  //   PageSize,
  //   columnName,
  //   columnValue,
  //   columnName1,
  //   columnValue1
  // ) {
  //   debugger;
  //   return baseURL.httpMSInventoryUrl.get(
  //     "StockInMasterTM/List/StartDate/EndDate/DocType/PageNum/PageSize?startDate=" +
  //       startDate +
  //       "&endDate=" +
  //       endDate +
  //       "&DocType=" +
  //       docType +
  //       "&pageNum=" +
  //       PageNum +
  //       "&pageSize=" +
  //       PageSize +
  //       "&columnName=" +
  //       columnName +
  //       "&columnValue=" +
  //       columnValue +
  //       "&columnName1=" +
  //       columnName1 +
  //       "&columnValue1=" +
  //       columnValue1 +
  //       ""
  //   );
  // }

  List(
    startDate,
    endDate,
    docType,
    PageNum,
    PageSize,
    columnName,
    columnValue,
    columnName1,
    columnValue1,
    columnName2,
    columnValue2,
    Flag,
    SearchOption,
    columnName3,
    columnValue3,
    columnName4,
    columnValue4,
    columnName5,
    columnValue5,
    columnName6,
    columnValue6,
    condtion
  ) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/List/StartDate/EndDate/DocType/PageNum/PageSize?startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&DocType=" +
        docType +
        "&pageNum=" +
        PageNum +
        "&pageSize=" +
        PageSize +
        "&columnName=" +
        columnName +
        "&columnValue=" +
        columnValue +
        "&columnName1=" +
        columnName1 +
        "&columnValue1=" +
        columnValue1 +
        "&columnName2=" +
        columnName2 +
        "&columnValue2=" +
        columnValue2 +
        "&columnName3=" +
        columnName3 +
        "&columnValue3=" +
        columnValue3 +
        "&columnName4=" +
        columnName4 +
        "&columnValue4=" +
        columnValue4 +
        "&columnName5=" +
        columnName5 +
        "&columnValue5=" +
        columnValue5 +
        "&columnName6=" +
        columnName6 +
        "&columnValue6=" +
        columnValue6 +
        "&Flag=" +
        Flag +
        "&SearchOption=" +
        SearchOption +
        "&Condition=" +
        condtion
    );
  }

  GetListByPIId(Id) {
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/GetListByPIId?Id=" + Id + ""
    );
  }

  UpdateApprovalStatus(EntityTransactionId, IsApproved) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockInMasterTM/UpdateApprovalStatus?EntityTransactionId=" +
        EntityTransactionId +
        "&IsApproved=" +
        IsApproved
    );
  }

  UpdateStockInDetailApprovalStatus(EntityTransactionId, IsApproved) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockInMasterTM/UpdateStockInDetailApprovalStatus?EntityTransactionId=" +
        EntityTransactionId +
        "&IsApproved=" +
        IsApproved
    );
  }

  GetByStockInId(Id) {
    return baseURL.httpMSInventoryUrl.get("StockInMasterTM/Get?id=" + Id + "");
  }
  //Insert/Update Barcode Item Allocation Details
  CreateBarCodeMapping(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockInDetailsTD/CreateBarCodeMapping",
      data
    );
  }
  CreateBarCodeMappingStockAdjust(RefId, RoomId, RackId, RowId, BoxId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockInDetailsTD/CreateBarCodeMappingStockAdjust?RefId=" +
        RefId +
        "&RoomId=" +
        RoomId +
        "&RackId=" +
        RackId +
        "&RowId=" +
        RowId +
        "&BoxId=" +
        BoxId
    );
  }
  GetItemByBarcode(Id) {
    return baseURL.httpMSInventoryUrl.get(
      "StockInDetailsTD/GetItemByBarcode?Id=" + Id + ""
    );
  }

  GetDCDocNoBySupplierId(SupplierId, StoreId, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/GetDCDocNoBySupplierId?SupplierId=" +
        SupplierId +
        "&StoreId=" +
        StoreId +
        "&BranchId=" +
        BranchId +
        ""
    );
  }
  GetDCDocNoByPOId(POId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/GetDCDocNoByPOId?POId=" + POId + ""
    );
  }
  GetItemsByDCNoId(DCNoIds) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockInMasterTM/GetItemsByDCNoId?StockInIds=" + DCNoIds + ""
    );
  }
    ListBatchNoSearchByStoreId(StoreId, BranchId, HospitalId, BatchNo) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockInDetailsTD/ListBatchNoSearchByStoreId?StoreId=" +
        StoreId +
        "&BranchId=" +
        BranchId +
        "&HospitalId=" +
        HospitalId +
        "&BatchNo=" +
        BatchNo +
        ""
    );
  }
}
export default new Commonservices();
